<template>
    <div>
        <v-toolbar dense color="primary" app :clipped-left="true" dark tabs>

            <v-btn icon @click="goBack()">
                <v-icon>arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>Caixas - Maps</v-toolbar-title>

        </v-toolbar>
        <main>
            <v-container fluid>

                <v-alert outline color="error" icon="warning" :value="error">
                    {{error}}
                </v-alert>

                <gmap-map  :center="center" :zoom="16" style="height: calc(60vh)">
                    <gmap-marker
                        :position="center"
                        :clickable="false"
                        :draggable="false"/>

                    <gmap-marker
                        v-for="i of items"
                        :key="i.text"
                        :icon="'/static/img/maps/map-marker.png'"
                        :position="{lat: i.value.place[1], lng: i.value.place[0]}"
                        :clickable="true"
                        @click="selecionar(i.value)"
                        :draggable="false"/>
                </gmap-map>

                <br/>
                <v-card v-if="ponto">
                    <v-card-title>
                        <div>
                            <span class="grey--text">Ponto</span><br>
                            <span>{{ ponto.nome }}</span>
                        </div>
                    </v-card-title>
                    <v-card-actions>
                        <v-btn flat @click="done()" color="orange">Confirmar</v-btn>
                    </v-card-actions>
                </v-card>

                <v-alert v-else outline color="error" icon="error" :value="true" >
                    Clique no Ponto
                </v-alert>

            </v-container>
        </main>
    </div>
</template>

<script>
    /* eslint-disable indent */

    import { Ordens } from "../class/ordens";
    import { Caixas } from "../class/caixas";
    import { Sync } from "../class/sync";

    export default {
        name: "buscar-caixas-google-maps",
        data () {
            return {
                limit: 2200,
                out: null,
                error: null,
                accuracy: null,
                items: [],
                center: { lat: 10.0, lng: 10.0 },
                watchID: null,
                buscando: false,
                ponto: null
            };
        },
        beforeDestroy () {
            if (this.watchID) {
                navigator.geolocation.clearWatch(this.watchID);
            }
        },
        beforeMount () {
            if (!this.$route.params.id || !parseInt(this.$route.params.id)) {
                return this.goBack();
            }
            Ordens
                .get(parseInt(this.$route.params.id))
                .then((ordem) => {
                    if (ordem) {
                        this.ordem = ordem;
                        this.center = { lat: this.ordem.geocode.latitude, lng: this.ordem.geocode.longitude };
                        this.getCaixas();
                    } else {
                        this.goBack();
                    }
                })
                .catch((err) => console.error(err));
        },

        methods: {
            goBack: function () {
                this.$router.go(-1);
            },
            getCaixas: function () {
                return Caixas
                    .proximas(250, this.ordem.geocode.latitude, this.ordem.geocode.longitude)
                    .then((res) => {
                        res.data.forEach((caixa) => {
                            this.items.push({ text: caixa.nome, value: caixa });
                        });
                        this.loading = false;
                    })
                    .catch((err) => console.error(err));
            },
            openLatLong: function () {
                this.dialog = false;
                this.watchID = navigator
                    .geolocation
                    .watchPosition(
                        this.processGeolocation,
                        this.geolocationError,
                        {
                            enableHighAccuracy: true,
                            timeout: 3000
                        }
                    );
            },
            processGeolocation: function (position) {
                console.log(position);
                this.out = position.coords.latitude + "," + position.coords.longitude;

                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                this.accuracy = position.coords.accuracy;

                if (this.accuracy <= this.limit) {
                    navigator.geolocation.clearWatch(this.watchID);
                    this.watchID = null;
                    this.getCaixas();
                }
            },
            geolocationError: function (error) {
                switch (error.code) {
                    case error.PERMISSION_DENIED:
                        this.error = "User denied the request for Geolocation.";
                        break;
                    case error.POSITION_UNAVAILABLE:
                        this.error = "Location information is unavailable.";
                        break;
                    case error.TIMEOUT:
                        this.error = "The request to get user location timed out.";
                        break;
                    case error.UNKNOWN_ERROR:
                        this.error = "An unknown error occurred.";
                        break;
                }
            },
            done: async function () {
                await Ordens.setCaixa(this.ordem.id_ordem_servico, this.ponto);

                let param = {
                    caixa: this.ponto,
                    id_ordem_servico: this.ordem.id_ordem_servico,
                    id_contratos_servicos: this.ordem.id_contratos_servicos,
                    action: "SYNC_CAIXA"
                };
                let key = await Sync.add(param);
                await Sync.syncOne(key, this.$socket);

                this.goBack();
            },
            selecionar (i) {
                console.log(i);
                this.ponto = i;
            }
        }
    };
</script>

<style scoped>

</style>
